import {API_DRIVER} from "../config/axios";

const getWishlistRequestUrl = (endpointUrl: string) => {
    return `/api/wishlist${endpointUrl}`
}

const WishlistService = {
    fetchWishlist: () => {
        return API_DRIVER.get(getWishlistRequestUrl(""))
    },
    addToWishlist: (wishId: string) => {
        return API_DRIVER.post(getWishlistRequestUrl(`/${wishId}`))
    },
    removeFromWishlist: (wishId: string) => {
        return API_DRIVER.delete(getWishlistRequestUrl(`/${wishId}`))
    }
}

export default WishlistService
